<!-- 事件图标组件 -->
<template>
    <div class="EventIconWrap">
      <!-- logo图标 -->
      <p
        v-if="event.logoFlag"
        :style="{ background: event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA':'#AE68F4' }">
        <i
          class="iconfont icon-LG"></i>
      </p>
      <!-- crawl图标 -->
      <p
        v-if="event.crawlFlag"
        :style="{ background: event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA':'#70BDE8' }">
        <i
          class="iconfont icon-CR"></i>
      </p>
      <!-- D图标 -->
      <p
        v-if="event.copy == 'true'"
        :style="{ background: event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA':'#67aa25' }">
        <i
          class="iconfont icon-duplicate1"></i>
      </p>
      <!-- cc图标 -->
      <p :style="{ background:event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA': '#aaaaaa' }">
        <i
          class="iconfont icon-cc"></i>
      </p>
      <!-- R图标 -->
      <p
        v-if="event.record"
        :style="{ background:event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
        <i
          class="iconfont icon-secondaryrecord"></i>
      </p>
      <p
        v-else
        :style="{ background:event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA': '#ec5050' }">
        <i
          class="iconfont icon-secondaryrecordoff"></i>
      </p>
      <!-- s图标 -->
      <p :style="{ background:event.liveStatus==2||event.liveStatus==4 ?'#AAAAAA': '#f2f2f2' }">
        <i
          class="iconfont icon-SCTEoff"></i>
      </p>
    </div>
</template>

<script>
export default {
  props: {
    // 事件信息
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.EventIconWrap {
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  padding-right: 1px;
  padding-top: 2px;
  p {
    width: 20px;
    height: 20px;
    background: #67aa25;
    text-align: center;
    line-height: 20px;
    margin-right: 2px;
    border-radius: 3px;
    i{
      color:#252525;
      font-size: 12px;
    }
    .icon-cc{
      font-size: 10px;
      transform: scale(0.7);
    }
    .icon-LG,.icon-CR,.icon-duplicate1 {
      transform: scale(0.8);
    }
  }
}
</style>
